var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "", "z-index": "600" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-chip",
                _vm._g(
                  { attrs: { color: _vm.color, "text-color": _vm.textColor } },
                  on
                ),
                [
                  _c("v-icon", { staticClass: "small mr-1 my-2" }, [
                    _vm._v("fa-clinic-medical")
                  ]),
                  _vm._v(_vm._s(_vm.text))
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", [
        _c("h2", [
          _vm._v(
            _vm._s(_vm.$t("global.insurance")) +
              " (" +
              _vm._s(_vm.$t("global.request")) +
              ")"
          )
        ]),
        _vm._v(
          " " +
            _vm._s(_vm.$t("travelService.place")) +
            ": " +
            _vm._s(_vm.placeText)
        ),
        _c("br"),
        _vm._v(
          " " +
            _vm._s(_vm.$t("global.startDate")) +
            ": " +
            _vm._s(_vm.travelServiceOrderItem.insurance.start_date)
        ),
        _c("br"),
        _vm._v(
          " " +
            _vm._s(_vm.$t("global.endDate")) +
            ": " +
            _vm._s(_vm.travelServiceOrderItem.insurance.end_date)
        ),
        _c("br")
      ]),
      _c("travel-service-order-item-common-tooltip-part", {
        attrs: { "travel-service-order-item": _vm.travelServiceOrderItem }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }